export default "__VITE_ASSET__BPEmp27f__"